<template>
  <div>
<!--    <el-button type="primary" @click="showDialog = true">修改密码</el-button>-->
    <el-dialog
      :title="title"
      :visible.sync="isShow"
      width="500px"
      :before-close="handleClose"
      :show-close="showClose"
    >
<!--      <h3 v-if="!showClose" style="margin-bottom: 5px;">根据系统安全要求，您的密码需要修改，修改后在进行其他操作！</h3>-->
      <el-form ref="passwordForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="原始密码" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="form.newPassword" @input="checkPasswordStrength"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="form.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="showClose" @click="resetForm">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  updatePwd
} from '@/api/user/login';
import {mapGetters} from "vuex";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "修改密码"
    }
  },
  data() {
    return {
      // showDialog: true,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.validatePasswordStrength, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '确认密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      },
      passwordStrengthMessage: ''
    };
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    validatePasswordStrength(rule, value, callback) {
      if (value.length < 8) {
        callback(new Error('密码太短'));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error('密码必须包含大写字母'));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error('密码必须包含小写字母'));
      } else if (!/[^A-Za-z0-9]/.test(value)) { // 检查是否包含特殊符号
        callback(new Error('密码必须包含特殊符号'));
      } else if (!/[0-9]/.test(value)) {
        callback(new Error('密码必须包含一个数字'));
      } else {
        callback();
      }
    },
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.form.newPassword) {
        callback(new Error('密码不匹配'));
      } else {
        callback();
      }
    },
    checkPasswordStrength() {
      const password = this.form.newPassword;
      if (password.length < 8) {
        this.passwordStrengthMessage = '密码太短';
      } else if (!/[A-Z]/.test(password)) {s
        this.passwordStrengthMessage = '密码必须包含大写字母';
      } else if (!/[a-z]/.test(password)) {
        this.passwordStrengthMessage = '密码必须包含小写字母';
      } else if (!/[0-9]/.test(password)) {
        this.passwordStrengthMessage = '密码必须包含数字';
      } else if (!/[^A-Za-z0-9]/.test(password)) {
        this.passwordStrengthMessage = '密码必须包含至少一个特殊符号';
      }  else {
        this.passwordStrengthMessage = '密码强度良好';
      }
    },
    resetForm() {
      this.$refs.passwordForm.resetFields();
      this.$emit('closeUpdatePwd'); // 触发自定义事件
      // done(this.showClose);
      // this.isShow = false;
    },
    handleClose(done) {
      if (this.showClose) {
        this.$emit('closeUpdatePwd'); // 触发自定义事件
      }
      done(this.showClose);
    },
    getCurrentTime() {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1，并且确保两位数
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    submitForm() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          updatePwd(this.form).then(res => {
            console.log(res.data.data)
            if (res.data.data.success) {
              this.$message.success("修改成功");
              this.$store.commit('SHOW_UPDATE_PASSWORD', false)
              this.$router.push({
                path: '/login'
              });
            } else {
              this.$message.error(res.data.data.msg);
            }
          }).catch((error) => {
            if (error.data && error.data.data.msg) {
              this.$message.error(error.data.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
